// extracted by mini-css-extract-plugin
export default {"item":"styles_item__RUW05","item__mobile":"styles_item__mobile__jkAZa"};